module.exports = __webpack_public_path__ + "img/artillery-wagon-base-shadow-14.f6a5d279.png";